var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ResultTable',{attrs:{"columns":_vm.columns,"data":_vm.tableData,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }